import React, {
    createContext, useMemo, useState,
} from 'react';

type AllEntitiesContextType = {
    currentEntityId: string | null;
    setCurrentEntityId: (id: string | null) => void;
};

export const AllEntitiesContext = createContext<AllEntitiesContextType | undefined>(undefined);

export const AllEntitiesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [currentEntityId, setCurrentEntityId] = useState<string | null>(null);

    const value = useMemo(
        () => ({
            currentEntityId, setCurrentEntityId,
        }),
        [currentEntityId],
    );

    return (
        <AllEntitiesContext.Provider value={value}>
            {children}
        </AllEntitiesContext.Provider>
    );
};
